import type { ApplicationLayoutProps } from '../components/Navigation/Navigation.types';

import { DesktopNavigation } from '../components/Navigation/DesktopNavigation';
import { MobileNavigation } from '../components/Navigation/MobileNavigation';
import { UserNavDropdown } from '../components/Navigation/UserNavDropdown';
import { ToastHistoryButton } from '../components/ToastHistory/ToastHistoryButton';

export const ApplicationLayout = (props: ApplicationLayoutProps) => {
  const {
    children,
    className,
    component,
    menuLinks,
    userMenuItems,
    homeLink,
    desktopNavClassName,
    triggerClassName,
    toastHistory = false,
  } = props;

  return (
    <div className={`flex h-full w-full max-w-full flex-row flex-nowrap ${className}`}>
      <DesktopNavigation
        links={menuLinks}
        homeLink={homeLink}
        className={desktopNavClassName}
        triggerClassName={triggerClassName}
      />
      {}
      <div className="h-screen w-full max-w-full overflow-auto">
        <header className="bg-muted/40 flex h-14 w-full items-center gap-4 border-b px-4 sm:h-[60px] lg:px-6">
          <MobileNavigation links={menuLinks} homeLink={homeLink} />
          <div className="w-full flex-1">{component}</div>
          {toastHistory && <ToastHistoryButton />}
          <UserNavDropdown menuItems={userMenuItems} />
        </header>
        <div className={'h-full w-full max-w-full p-4'}>{children}</div>
      </div>
    </div>
  );
};
